import axios from 'axios';
import { BASE_URL } from '../ApiService/ApiConfig';

const obtenerConfig = () => {
    const token = localStorage.getItem('jwt').replaceAll('"', '');

    return {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            Authorization: 'Bearer ' + token
        }
    };
};

export const recuperarDotacionesXEmpleado = async (empleadoId) => {
    try {
        const response = await axios.get(
            `${BASE_URL}/nomina/dotacion/empleado/${empleadoId}`,
            obtenerConfig()
        );
        return response.data;
    } catch (error) {
        console.error(`Error al obtener las Dotaciones`, error);
        throw new Error('Error al obtener las Dotaciones');
    }
};

export const crearDotacion = async (ojbData) => {
    try {
        const response = await axios.post(`${BASE_URL}/nomina/dotacion`, ojbData, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error(`Error al obtener las Dotaciones`, error);
        throw new Error('Error al obtener las Dotaciones');
    }
};

export const actualizaDotacion = async (ojbData) => {
    try {
        const response = await axios.put(`${BASE_URL}/nomina/dotacion`, ojbData, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error(`Error al obtener las Dotaciones`, error);
        throw new Error('Error al obtener las Dotaciones');
    }
};

export const guardarDocumentoDotacion = async (formData) => {
    try {
        const response = await axios.post(
            `${BASE_URL}/nomina/documentoCab/crear`,
            formData,
            obtenerConfig()
        );
        return response.data;
    } catch (error) {
        console.error(`Error al obtener las Dotaciones`, error);
        throw new Error('Error al obtener las Dotaciones');
    }
};

export const recuperaImagenBitXEntidad = async (entidadId, tipoConfId, tipoId) => {
    try {
        const response = await axios.get(
            `${BASE_URL}/nomina/documentoCab/entidadTipo/${entidadId}/${tipoConfId}/${tipoId}`,
            obtenerConfig()
        );
        return response.data;
    } catch (error) {
        console.error(`Error al Imagenes`, error);
        throw new Error('Error al obtener imagenes');
    }
};

export const recuperaImagenByLista = async (objPost) => {
    try {
        const response = await axios.post(
            `${BASE_URL}/nomina/documentos/byLista`,
            objPost,
            obtenerConfig()
        );
        return response.data;
    } catch (error) {
        console.error(`Error al Imagenes`, error);
        throw new Error('Error al obtener imagenes');
    }
}


export const anulaDotacion = async (dotacionId) => {
    try {
        console.log('DATO BORRAR:..: ', dotacionId)
        const response = await axios.get(`${BASE_URL}/nomina/dotacion/anular/${dotacionId}`,
            obtenerConfig())
        return response.data
    } catch (error) {
        console.error(`Error Anulando Dotacion`, error);
        throw new Error('Error al anular la Dotacion');
    }
}
